<app-card cardTitle="Aggiungi una nuova Experience" [options]="false">
    <form action="javascript:;" [formGroup]="prizeForm">
        <div class="row">
            <div class="col-12">
                <div class="form-group mt-3">
                    <label for="titolo">TITOLO*</label>
                    <input formControlName="title" type="text" class="form-control" id="title" aria-describedby="title" placeholder="Titolo Prize">
                   <small id="titleHelp" class="form-text text-muted">Scrivi un titolo per il Prize</small>
                </div>
                <div class="form-group mt-3">
                    <label for="subtitle">DESCRIZIONE AGGIUNTIVA</label>
                    <input formControlName="subtitle" type="text" class="form-control" id="subtitle" aria-describedby="subtitle" placeholder="Sottotitolo Prize">
                   <small id="subtitleHelp" class="form-text text-muted">Scrivi un sottotitolo per il Prize</small>
                </div>
                <div class="form-group mt-3">
                    <label for="link">LINK</label>
                    <input formControlName="link" type="text" class="form-control" id="link" aria-describedby="link" placeholder="Link Prize">
                   <small id="linkHelp" class="form-text text-muted">Inserisci un link esterno per il Prize.</small>
                </div>
                <div class="form-group">
                    <label for="description">DESCRIZIONE*</label>
                    <textarea  formControlName="description" class="form-control" id="description" aria-describedby="descriptionHelp"></textarea>
                    <small id="descriptionHelp" class="form-text text-muted">Scrivi una descrizione che rappresenti il Prize</small>
                </div>
                <div class="form-group">
                    <label>IMMAGINE PRIZE</label>
                    <app-media-manager [filePath]="f.image.value" (onFileSelect)="setImageUrl($event)"></app-media-manager>
                </div>
                <div class="col-sm-12 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary" [disabled]="!prizeForm.valid" (click)="editPrize()">Salva</button>
                </div>
            </div>
        </div>
    </form>
</app-card>